module.exports = __webpack_public_path__ + "img/meetingIndex_ico06.88951e5a.png";